import { createAction } from '@reduxjs/toolkit';
import type { FileManagerRow } from '../fileManager/model';

export const convertCreativeButtonClicked = createAction<
  void,
  'ch/creativeConverter/CONVERT_CREATIVE_BUTTON_CLICKED'
>('ch/creativeConverter/CONVERT_CREATIVE_BUTTON_CLICKED');

export const nodesAdded = createAction<
  { nodes: FileManagerRow[]; skipReadyManualProcessing: boolean },
  'ch/creativeConverter/NODES_ADDED'
>('ch/creativeConverter/NODES_ADDED');
export const jobErrorChanged = createAction<
  { nodeID: number; error: string },
  'ch/creativeConverter/JOB_ERROR_CHANGED'
>('ch/creativeConverter/JOB_ERROR_CHANGED');
export const jobFinished = createAction<{ nodeID: number }, 'ch/creativeConverter/JOB_FINISHED'>(
  'ch/creativeConverter/JOB_FINISHED',
);
export const closeButtonClicked = createAction<void, 'ch/creativeConverter/CLOSE_BUTTON_CLICKED'>(
  'ch/creativeConverter/CLOSE_BUTTON_CLICKED',
);

export const creativeFixed = createAction<
  { creativeTypeID: number; settings: Record<string, string> },
  'ch/creativeConverter/creativeFixed'
>('ch/creativeConverter/creativeFixed');
export const cacheCleared = createAction<void, 'ch/creativeConverter/cacheCleared'>(
  'ch/creativeConverter/cacheCleared',
);

export const promptVisibilityChanged = createAction<
  { visible: boolean },
  'ch/creativeConverter/promptVisibilityChanged'
>('ch/creativeConverter/promptVisibilityChanged');
export const promptResolved = createAction<
  { result: boolean },
  'ch/creativeConverter/promptResolved'
>('ch/creativeConverter/promptResolved');

export const readyPromptVisibilityChanged = createAction<
  { visible: boolean; readyCount: number; otherCount: number },
  'ch/creativeConverter/readyPromptVisibilityChanged'
>('ch/creativeConverter/readyPromptVisibilityChanged');
export const readyPromptResolved = createAction<
  { result: boolean },
  'ch/creativeConverter/readyPromptResolved'
>('ch/creativeConverter/readyPromptResolved');
